import { render, staticRenderFns } from "./UserLatestReports.vue?vue&type=template&id=6909f55a&scoped=true"
import script from "./UserLatestReports.vue?vue&type=script&lang=js"
export * from "./UserLatestReports.vue?vue&type=script&lang=js"
import style0 from "./UserLatestReports.vue?vue&type=style&index=0&id=6909f55a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6909f55a",
  null
  
)

export default component.exports